<template>
  <div class="pm-dialog-boardside-type">
    <div class="flex justify-center dialog-content" style="padding:1rem;">
      <div
        class="vs-col"
        v-for="(master,index) in masterList"
        :key="index"
        style="margin:0.2rem;"
        @mousedown="selectedId = (selectedId !== master.id) ? master.id : -1"
      >
        <vs-chip
          class="pm-input-key"
          :color="(selectedId == master.id) ? '#2d9cdb' : null "
        >
          {{ 
            master.id === 1 ? '左' :
            master.id === 2 ? '右' : 
            master.id === 3 ? '左' :
            master.id === 4 ? '右' :
            master.id === 5 ? '？' : ""
          }}
          <feather-icon v-if="master.id === 3 || master.id === 4" icon="RefreshCcwIcon" svgClasses="h-4 w-4" class="pm-boardside-type-icon" />
        </vs-chip>
      </div>
    </div>

    <div class="flex justify-center">
      <vs-button 
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(false)"
        v-shortkey="{save: ['enter'], saveWithUpdateTime: ['shift', 'enter']}" @shortkey="callKeyActions"
      >
        保存
      </vs-button>
      <vs-button
        v-if="!isImportEditMode && !isInsertOneMode"
        :color="enableSave ? '#2d9cdb' : '#bdbdbd'"
        class="save-button"
        @mousedown="onSubmit(true)"
      >
        ハイライト保存
      </vs-button>
    </div>

  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
// Editでは修正
// const { mapActions, mapState, mapGetters } = createNamespacedHelpers("portMasterDestinationWork");
const { mapState } = createNamespacedHelpers("portMasterDestinationWorkEdit");

export default {
  props: {
    taskId:    { type: String, required: true },
    columnKey: { type: String, required: true },
    valueMap:  { required: true },
    isImportEditMode: { type: Boolean,  default: false },
    isInsertOneMode:  { type: Boolean,  default: false },
  },
  data() {
    return {
      selectedId: -1,
    };
  },
  watch: {
    taskId() {
      this.initData();
    },
    summaryDialogShowPopup() {
      if ( this.summaryDialogShowPopup === true ) {
        this.initData();
      }
    },
  },
  computed: {
    ...mapState({
      masterMap: state => state.masterMap,
      summaryDialogShowPopup:  state => state.summaryDialogShowPopup,
    }),
    masterList() {
      return this.masterMap['boardside_type'];
    },
    enableSave() {
      return true; // ( this.selectedId && this.selectedId >= 0 );
    },
  },
  methods: {
    initData() {
      this.selectedId = this.valueMap ? this.valueMap.id : null;
    },
    callKeyActions(event) {
      switch (event.srcKey) {
      case 'save':
        if (this.enableSave) this.onSubmit(false, true)
        break
      case 'saveWithUpdateTime':
        if (this.enableSave) this.onSubmit(true, true)
        break
      }
    },
    onSubmit(isUpdateTimeStamp, toNextColumn = false) {
      let mode = []
      if (isUpdateTimeStamp) mode.push("updateTimeStamp")
      if (toNextColumn) mode.push("toNextColumn")
      const updateKeyValueMap = {};
      updateKeyValueMap[this.columnKey] = this.selectedId;
      this.$emit('updateValue',this.taskId, updateKeyValueMap, mode, this.columnKey);
    },
  },
  mounted() {
    this.initData();
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/port-master/_variables.scss";
.pm-dialog-boardside-type {
  .dialog-content {
    flex-wrap: wrap;
  }
  .con-vs-chip {
    border-radius:5px;
    height:2.2rem;
    font-size: 120%;
  }
  .pm-input-key {
    background-color: $pm-paper-white;
    border: 1px solid $pm-gray;
    color: $pm-black;
    cursor: pointer;
  }
  .pm-boardside-type-icon {
    padding-left: 0.4rem;
  }
  .save-button {
    margin: 1rem !important;
    width: 30%;
  }
}
</style>

